import {Injectable} from '@angular/core';
import {Observable} from "rxjs/Observable";
import {AppSettings} from "../app.settings";
import {AgentUtility} from "../util/agent.utility";
import {Base2Service} from "./base2.service";
import {ResponseApi} from "./response/response";
import {HttpHeaders} from "@angular/common/http";

@Injectable()
export class ContractsService extends Base2Service {

    getContracts(filter: FilterContracts): Observable<ResponseApi> {
        let localuser = AgentUtility.getUser();
        filter.AgentId = localuser.Id;
        return this.request<ResponseApi>("POST", AppSettings.apiUrl + 'contracts', filter);
    }

    getActiveCount(): Observable<ResponseApi> {
        let localuser = AgentUtility.getUser();
        return this.request<ResponseApi>("GET", AppSettings.apiUrl + 'contracts/count/' + localuser.Id);
    }

    getContractFromBorlas(number: number): Observable<ResponseApi> {
        let localuser = AgentUtility.getUser();
        return this.request<ResponseApi>("GET", AppSettings.apiUrl + 'contracts/borlas/' + number + '/' + localuser.Id);
    }

    getProductListAgentsArray(agents): Observable<ResponseApi> {
        return this.request<ResponseApi>("POST", AppSettings.apiUrl + 'products/agents', agents);
    }

    getProductList(): Observable<any> {
        let user = AgentUtility.getUser();
        return this.request<ResponseApi>("GET", AppSettings.apiUrl + 'products/' + user.Id);
    }

    getStatusesAgentsArray(agents): Observable<ResponseApi> {
        return this.request<ResponseApi>("POST", AppSettings.apiUrl + 'statuses/agents', agents);
    }

    getStatusesList(): Observable<ResponseApi> {
        let user = AgentUtility.getUser();
        return this.request<ResponseApi>("GET", AppSettings.apiUrl + 'statuses/agent/' + user.Id);
    }

    getUrlPayments(agents): Observable<ResponseApi> {
        let headers = new HttpHeaders({
            'content-type': 'application/json',
            'X-Auth-Token': 'cmn9E6RsyDiK7ASXEeFi5gTfrRP88W4Z'
        });
        return this.request<ResponseApi>("POST", AppSettings.urlPayments, agents, headers);
    }
}

export class FilterContracts {
    Id?: number;
    AgentId?: number;
    ProductId?: number;
    Status?: number;
    limit?: any;
    page?: number;
    StartDate?: Date;
    EndDate?: Date;
    excel: boolean = false;
    StatusId?: number;
    agents?: number[];
}